import { PromiseWithResolver } from './PromiseWithResolver';
export default function waitReject(duration, reason = 'TIMED_OUT') {
    let resolver;
    const promise = new PromiseWithResolver((resolve, reject) => {
        const timeoutId = setTimeout(() => reject(reason), duration);
        resolver = () => {
            clearTimeout(timeoutId);
            resolve();
        };
    });
    promise.resolve = resolver;
    return promise;
}
